import React, { useState, useEffect } from 'react'
import {
  FlexboxGrid,
  Grid,
  Row,
  Col,
  Panel,
  Table,
  CheckPicker,
  Button,
  CheckTreePicker,
  Icon,
} from 'rsuite'
import TopLevelNav from '../../../components/TopLevelNav'
import PageToolbar from '../../../components/PageToolbar'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import PanalLoadingTemplate from '../../loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { doneLoading, startLoading } from '../../../utils/loading'
import ErrorWidget from '../../errorWidget/ErrorWidget'
import './styles.css'

import DoughnutChart from '../../dashboard/charts/echartWidgets/DoughnutChart'
import PieChart from '../../dashboard/charts/echartWidgets/PieChart'
import BasicBarChart from '../../dashboard/charts/echartWidgets/BasicBarChart'
import BasicLineChart from '../../dashboard/charts/echartWidgets/BasicLineChart'
import PieChartsOnGeoMap from '../../dashboard/charts/echartWidgets/PieChartsOnGeoMap'
import { Controller, useForm } from 'react-hook-form'
import {
  getBasicKnowledgeAndSkillsAssScore,
  searchBasicKnowledgeAndSkillsAssScore,
} from '../../../redux/actions/dashboardDep6'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'

export default function BasicKnowledgeAndSkillsAssScore() {
  const { register, handleSubmit, errors, control, reset, clearErrors } = useForm()

  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()

  const [sortColumn, setSortColumn] = useState()
  const [sortType, setSortType] = useState()
  const [isLoadingTable, setIsLoadingTable] = useState(false)

  const { Column, HeaderCell, Cell, Pagination } = Table

  const [summaryId, setSummaryId] = useState()
  const [qrtyPerNodeId, setQtyPerNodeId] = useState()
  const [qryPerAgencyId, setQryPerAgencyId] = useState()
  const [levelCountKnowledgeSkillSso, setLevelCountKnowledgeSkillSso] = useState()
  const [levelCountKnowledgeSkillSsoDep6, setLevelCountKnowledgeSkillSsoDep6] = useState()
  const [levelCountByProject, setLevelCountByProject] = useState()
  const [levelCountByProjectSelfAss, setLevelCountByProjectSelfAss] = useState()
  const [levelUnderstanding, setLevelUnderstanding] = useState()
  const [levelUnderstandingSelfAss, setLevelUnderstandingSelfAss] = useState()
  const [projectAreaId, setProjectAreaId] = useState()
  const [projectCode, setProjectCode] = useState()

  const [evaluation, setEvaluation] = useState()
  const [locationProvince, setLocationProvince] = useState()
  const [nodeType, setNodeType] = useState()
  const [role, setRole] = useState()
  const [roleUnderTream, setRoleUnderTream] = useState()
  const [agency, setAgency] = useState()
  const [experience, setExperience] = useState()
  const [criOrderBy, setCriOrderBy] = useState()

  const _styles = {
    panel: {
      backgroundColor: '#34a888',
    },
    titleMesage: {
      color: '#ffffff',
    },
    content: {
      marginTop: 20,
    },
    icon: {
      paddingRight: 10,
    },
    footer: {
      marginTop: 15,
    },
    button: {
      width: 120,
      color: '#ffffff',
      backgroundColor: '#575757',
      fontWeight: 'bold',
      fontSize: '14 !important',
    },
  }

  useEffect(() => {
    // console.log('load ref ID => ', referenceID)

    handleGetResponse()
  }, [])

  const mockSchema = {
    forms: {
      header: 'รายงานคะแนนประเมินความรู้และทักษาะพื้นฐาน สำนัก 6',
      summary: [
        {
          setCol: { xxs: 24, xsm: 12, xmd: 6, xlg: 12 },
          data: {
            id: 'x01',
            title: 'จำนวนผู้ตอบแบบสอบถามทั้งหมด',
            value: '45',
            bgcolor: '#99ccff',
          },
        },
        {
          setCol: { xxs: 24, xsm: 12, xmd: 6, xlg: 6 },
          data: { id: 'x01', title: 'บทบาททีมประเมิน', value: '45', bgcolor: '#f899cc' },
        },
        {
          setCol: { xxs: 24, xsm: 12, xmd: 6, xlg: 6 },
          data: { id: 'x01', title: 'บทบาททีมประเมินและทีมพัฒนา', value: '45', bgcolor: '#e4ea8e' },
        },
      ],
      dashboardInfo: {
        numberPartnersUnitEvaluationTeam: {
          title: 'จำนวนภาคี จำแนกตามประเภททีมประเมินหน่วยจัดการ',
          setting: {
            seriesData: [
              { value: 58.33, name: 'N1 = Node จังหวัด 28 (58.33%)' },
              { value: 12.5, name: 'N2 = Node Flagship 6 (12.5%' },
              { value: 8.33, name: 'N3 = แผนงานร่วมทุน 4 (8.33%)' },
              { value: 14.58, name: 'N5 = Node เด็กและเยาวชน 7 (14.58%)' },
              { value: 2.08, name: 'N7 = Node ....' },
            ],
          },
        },
        numberPartnersClassifiedAgencyType: {
          title: 'จำนวนภาคี จำแนกตามประเภทหน่วยงาน',
          setting: {
            seriesData: [
              { value: 58.33, name: 'N1 = Node จังหวัด 28 (58.33%)' },
              { value: 12.5, name: 'N2 = Node Flagship 6 (12.5%' },
              { value: 8.33, name: 'N3 = แผนงานร่วมทุน 4 (8.33%)' },
              { value: 14.58, name: 'N5 = Node เด็กและเยาวชน 7 (14.58%)' },
              { value: 2.08, name: 'N7 = Node ....' },
            ],
          },
        },
        numberPartnersBasicKnowledge: {
          title: 'จำนวนภาคี จำแนกตามระดับความรู้พื้นฐาน สสส.',
          setting: {
            xAxisData: [
              'ระดับ ปรับปรุง',
              'ระดับ น้อย',
              'ระดับ ปานกลาง',
              'ระดับ มาก',
              'ระดับ มากที่สุด',
            ],
            // seriesData: [0, 0, 0, 1, 44],
            seriesData: [
              { value: 0, id: '4821' },
              { value: 0, id: '4822' },
              { value: 0, id: '4823' },
              { value: 44, id: '4824' },
            ],
            barColor: '#96d897',
            axisLabelConfig: {
              interval: 0, // แสดง label ทุกรายการ
              rotate: 10, // หมุน label 45 องศา
              fontSize: 10, // ขนาดตัวอักษร
              margin: 10, // ระยะห่างจาก axis
            },
            yAxisName: 'จำนวนโครงการ',
            xAxisName: 'ระดับผลคะแนน',
            xNameLocation: 'middle',
            xNameGap: 40,
          },
        },
        basicUnderstandingJob: {
          title: 'ระดับความเข้าใจพื้นฐานของงาน สสส.และสำนัก 6',
          setting: {
            xAxisData: ['1', '2', '3', '4', '5'],
            seriesData: [0, 0, 0, 1, 44],
            barColor: '#99ccff',
            yAxisName: 'จำนวนโครงการ',
            xAxisName: 'ระดับผลคะแนน',
            xNameLocation: 'middle',
            xNameGap: 30,
          },
        },
        levelUnderstandingProjectEvaluation: {
          title: 'ระดับความเข้าใจหลัการประเมินผลโครงการ',
          setting: {
            xAxisData: ['1', '2', '3', '4', '5'],
            seriesData: [0, 0, 1, 6, 39],
            barColor: '#f899cc',
            yAxisName: 'จำนวนโครงการ',
            xAxisName: 'ระดับผลคะแนน',
            xNameLocation: 'middle',
            xNameGap: 30,
          },
        },
        projectEvaluationSkillLevel: {
          title: 'ระดับทักษะด้านการประเมินผลโครงการ (ประเมินตนเอง)',
          setting: {
            xAxisData: ['ระดับ 1', 'ระดับ 2', 'ระดับ 3', 'ระดับ 4', 'ระดับ 5'],
            seriesData: [0, 3, 11, 14, 17],
            barColor: '#f899cc',
            yAxisName: 'จำนวนโครงการ',
            xAxisName: 'ระดับผลคะแนน',
            xNameLocation: 'middle',
            xNameGap: 30,
          },
        },
        levelUnderstandingCapacityDevelopment: {
          title: 'ระดับความเข้าใจหลักการพัฒนาศักยภาพภาคี',
          setting: {
            xAxisData: ['1', '2', '3', '4', '5'],
            seriesData: [0, 3, 11, 14, 17],
            barColor: '#e4ea8e',
            yAxisName: 'จำนวนโครงการ',
            xAxisName: 'ระดับผลคะแนน',
            xNameLocation: 'middle',
            xNameGap: 30,
          },
        },
        partnetCapacityDevelopmentSkillsLevel: {
          title: 'ระดับทักษะด้านการพัฒนาศักยภาพภาคี (ประเมินตนเอง)',
          setting: {
            xAxisData: ['ระดับ 1', 'ระดับ 2', 'ระดับ 3', 'ระดับ 4', 'ระดับ 5'],
            seriesData: [0, 2, 13, 14, 17],
            barColor: '#e4ea8e',
            yAxisName: 'จำนวนโครงการ',
            xAxisName: 'ระดับผลคะแนน',
            xNameLocation: 'middle',
            xNameGap: 30,
          },
        },
        projectOfArea: {
          title: 'จำนวนโครงการรายพื้นที่',
          setting: {
            provinceDataFrom: [
              {
                name: 'เชียงใหม่',
                center: null,
                data: [
                  { value: 40, name: 'R1' },
                  { value: 60, name: 'R2' },
                ],
              },
              {
                name: 'เชียงราย',
                center: null,
                data: [
                  { value: 35, name: 'R1' },
                  { value: 65, name: 'R2' },
                ],
              },
            ],
          },
        },
        projectDetail: {
          title: 'รายละเอียดโครงการ',
          values: [
            {
              fullName: 'กนกพร พรมจันทร์',
              role: ' R1 = ทีมประเมิน',
              workExperience: '1 - 3 ปี',
              projectType: 'N1 = Node จังหวัด',
              score: 'ระดับ มากที่สุด',
              agency: 'อื่นๆ เช่น นักวิชาการอิสระ',
              position: 'P3 = นักวิจัย / นักวิเคราะห์ / นักประเมิน',
              sector: 'ภาคกลาง',
              province: 'กรุงเทพมหานคร',
            },
            {
              fullName: 'สมฤทัย เมฆา',
              role: ' R1 = ทีมประเมิน',
              workExperience: '1 - 3 ปี',
              projectType: 'N1 = Node จังหวัด',
              score: 'ระดับ มากที่สุด',
              agency: 'อื่นๆ เช่น นักวิชาการอิสระ',
              position: 'P3 = นักวิจัย / นักวิเคราะห์ / นักประเมิน',
              sector: 'ภาคกลาง',
              province: 'กรุงเทพมหานคร',
            },
            {
              fullName: 'ชมจันทร์ เดือนหงาย',
              role: ' R1 = ทีมประเมิน',
              workExperience: '1 - 3 ปี',
              projectType: 'N1 = Node จังหวัด',
              score: 'ระดับ มากที่สุด',
              agency: 'อื่นๆ เช่น นักวิชาการอิสระ',
              position: 'P3 = นักวิจัย / นักวิเคราะห์ / นักประเมิน',
              sector: 'ภาคกลาง',
              province: 'กรุงเทพมหานคร',
            },
          ],
        },
      },
      searchForms: {
        evaluation: {
          name: 'evaluation',
          label: 'เกณฑ์การประเมิน',
          value: '',
          options: [
            { disabled: false, label: 'ระดับ ปรับปรุง', value: '1' },
            { disabled: false, label: 'ระดับ น้อย', value: '2' },
            { disabled: false, label: 'ระดับ ปานกลาง', value: '3' },
            { disabled: false, label: 'ระดับ มาก', value: '4' },
            { disabled: false, label: 'ระดับ มากที่สุด', value: '5' },
          ],
        },
        location: {
          name: 'location',
          label: 'จังหวัด',
          options: [
            {
              label: 'ภาค',
              value: 1,
              children: [
                {
                  label: 'จังหวัด',
                  value: 11,
                  children: [
                    {
                      label: 'อำเภอ',
                      value: 22,
                    },
                  ],
                },
              ],
            },
          ],
        },
        nodeType: {
          name: 'nodeType',
          label: 'ประเภทโครงการ',
          value: '',
          options: [
            { disabled: false, label: 'N1 = Node จังหวัด', value: '1' },
            { disabled: false, label: 'N2 = Node Flagship', value: '2' },
            { disabled: false, label: 'N3 = แผนงานร่วมทุน', value: '3' },
          ],
        },
        roles: {
          name: 'roles',
          label: 'บทบาท',
          value: '',
          options: [
            { disabled: false, label: 'R1 = ทีมประเมิน', value: '1' },
            { disabled: false, label: 'R2 = ทีมพัฒนาศักยภาพ', value: '2' },
          ],
        },
        rolesUnderTream: {
          name: 'rolesUnderTream',
          label: 'บทบาทภายใต้ทีม',
          value: '',
          options: [
            { disabled: false, label: 'A1 = หัวหน้าทีมประเมิน', value: '1' },
            { disabled: false, label: 'A2 = ทีมประเมิน', value: '2' },
          ],
        },
        agency: {
          name: 'agency',
          label: 'หน่วยงานที่สังกัด',
          value: '',
          options: [
            { disabled: false, label: 'ภาคประชาสังคม', value: '1' },
            { disabled: false, label: 'ภาคราชการ', value: '2' },
          ],
        },
        experience: {
          name: 'experience',
          label: 'ประสบการณ์ดำเนินงาน',
          value: '',
          options: [
            { disabled: false, label: '1 - 3 ปี', value: '1' },
            { disabled: false, label: '4 - 6 ปี', value: '2' },
          ],
        },
        button: {
          search: {
            setCol: { xxs: 24, xsm: 24, xmd: 24, xlg: 12 },
            label: 'ค้นหา',
          },
          cancel: {
            setCol: { xxs: 24, xsm: 24, xmd: 24, xlg: 24 },
            label: 'ยกเลิก',
          },
          exportExcel: {
            setCol: { xxs: 24, xsm: 24, xmd: 24, xlg: 12 },
            label: 'Download Excel',
          },
        },
      },
    },
  }

  const handleGetResponse = async () => {
    setIsLoading(true)
    startLoading()

    try {
      const res = await getBasicKnowledgeAndSkillsAssScore()
      console.log('res => ', res)

      // setChartMapOption(optionMapChart)
      setSchema(res.forms)
    } catch (e) {
      console.log('error => ', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }

    doneLoading()
    setIsLoading(false)
  }

  const handleCancel = () => {
    setSummaryId()
    setQtyPerNodeId()
    setQryPerAgencyId()
    setLevelCountKnowledgeSkillSso()
    setLevelCountKnowledgeSkillSsoDep6()
    setLevelCountByProject()
    setLevelCountByProjectSelfAss()
    setLevelUnderstanding()
    setLevelUnderstandingSelfAss()
    setProjectAreaId()
    setProjectCode()
    setEvaluation()
    setLocationProvince()
    setNodeType()
    setRole()
    setRoleUnderTream()
    setAgency()
    setExperience()
    setCriOrderBy()

    handleGetResponse()
  }

  const handleExportExcel = () => {
    alert('handleExportExcel')
  }

  const handleSearch = async () => {
    console.log('handleSearch')

    const req = {
      summaryId: summaryId || '',
      qtyPerNodeId: qrtyPerNodeId || '',
      qryPerAgencyId: qryPerAgencyId || '',
      levelCountKnowledgeSkillSso: levelCountKnowledgeSkillSso || '',
      levelCountKnowledgeSkillSsoDep6: levelCountKnowledgeSkillSsoDep6 || '',
      levelCountByProject: levelCountByProject || '',
      levelCountByProjectSelfAss: levelCountByProjectSelfAss || '',
      levelUnderstanding: levelUnderstanding || '',
      levelUnderstandingSelfAss: levelUnderstandingSelfAss || '',
      projectAreaId: projectAreaId || '',
      projectCode: projectCode || '',
      evaluation: evaluation?.length > 0 ? evaluation.toString() : '',
      locationProvince: locationProvince?.length > 0 ? locationProvince.toString() : '',
      nodeType: nodeType?.length > 0 ? nodeType.toString() : '',
      role: role?.length > 0 ? role.toString() : '',
      roleUnderTream: roleUnderTream?.length > 0 ? roleUnderTream.toString() : '',
      agency: agency?.length > 0 ? agency.toString() : '',
      experience: experience?.length > 0 ? experience.toString() : '',
      criOrderBy: criOrderBy || '',
    }

    await callApiSearch(req)
  }

  const handleClickSearch = async (ctype = null, cid = null) => {
    const req = {
      summaryId: ctype == 'summary' ? cid || '' : summaryId || '',
      qtyPerNodeId: ctype == 'qrtyPerNode' ? cid || '' : qrtyPerNodeId || '',
      qryPerAgencyId: ctype == 'qryPerAgency' ? cid || '' : qryPerAgencyId || '',
      levelCountKnowledgeSkillSso:
        ctype == 'levelCountKnowledgeSkillSso' ? cid || '' : levelCountKnowledgeSkillSso || '',
      levelCountKnowledgeSkillSsoDep6:
        ctype == 'levelCountKnowledgeSkillSsoDep6'
          ? cid || ''
          : levelCountKnowledgeSkillSsoDep6 || '',
      levelCountByProject: ctype == 'levelCountByProject' ? cid || '' : levelCountByProject || '',
      levelCountByProjectSelfAss:
        ctype == 'levelCountByProjectSelfAss' ? cid || '' : levelCountByProjectSelfAss || '',
      levelUnderstanding: ctype == 'levelUnderstanding' ? cid || '' : levelUnderstanding || '',
      levelUnderstandingSelfAss:
        ctype == 'levelUnderstandingSelfAss' ? cid || '' : levelUnderstandingSelfAss || '',
      projectAreaId: ctype == 'projectArea' ? cid || '' : projectAreaId || '',
      projectCode: ctype == 'projectCode' ? cid || '' : projectCode || '',
      evaluation: evaluation?.length > 0 ? evaluation.toString() : '',
      locationProvince: locationProvince?.length > 0 ? locationProvince.toString() : '',
      nodeType: nodeType?.length > 0 ? nodeType.toString() : '',
      role: role?.length > 0 ? role.toString() : '',
      roleUnderTream: roleUnderTream?.length > 0 ? roleUnderTream.toString() : '',
      agency: agency?.length > 0 ? agency.toString() : '',
      experience: experience?.length > 0 ? experience.toString() : '',
      criOrderBy: ctype == 'criOrderBy' ? cid || '' : criOrderBy || '',
    }

    switch (ctype) {
      case 'summary':
        setSummaryId(cid)
        break

      case 'qrtyPerNode':
        setQtyPerNodeId(cid)
        break

      case 'qryPerAgency':
        setQryPerAgencyId(cid)
        break

      case 'levelCountKnowledgeSkillSso':
        setLevelCountKnowledgeSkillSso(cid)
        break

      case 'levelCountKnowledgeSkillSsoDep6':
        setLevelCountKnowledgeSkillSsoDep6(cid)
        break

      case 'levelCountByProject':
        setLevelCountByProject(cid)
        break

      case 'levelCountByProjectSelfAss':
        setLevelCountByProjectSelfAss(cid)
        break

      case 'levelUnderstanding':
        setLevelUnderstanding(cid)
        break

      case 'levelUnderstandingSelfAss':
        setLevelUnderstandingSelfAss(cid)
        break

      case 'projectArea':
        setProjectAreaId(cid)
        break

      case 'projectCode':
        setProjectCode(cid)
        break

      case 'criOrderBy':
        setCriOrderBy(cid)
        break

      default:
        break
    }

    await callApiSearch(req)
  }

  const callApiSearch = async (req) => {
    setIsLoading(true)
    startLoading()

    try {
      var response = await searchBasicKnowledgeAndSkillsAssScore(req)
      console.log('resssss => ', response)
      setSchema(response.forms)
    } catch (e) {
      console.log('error => ', e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 2500,
      })
    }

    doneLoading()
    setIsLoading(false)
  }

  console.log('isLoading => ', isLoading)

  if (error) {
    return (
      <Row>
        <Col xs={24} sm={24} md={24} lg={24}>
          <ErrorWidget statusCode={error?.statusCode} errorMessage={error?.errorMessage} />
        </Col>
      </Row>
    )
  }

  if (!schema || isLoading) {
    return (
      <Row>
        <Col xs={24} sm={24} md={24} lg={24}>
          <OverlayLoader />
          <PanalLoadingTemplate />
        </Col>
      </Row>
    )
  }

  const CardAmt = (props) => {
    // console.log('props => ', props)
    return (
      <Panel
        {...props}
        bordered
        className="card-amt-panel"
        style={{ backgroundColor: props.data.bgcolor }}
        onClick={() => {
          handleClickSearch('summary', props?.data?.id)
        }}
      >
        <Row>
          <Col md={24} sm={24} xs={24} style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 48, fontWeight: 'bold' }}>{props.data.value}</div>
            <div>{props.data.title}</div>
          </Col>
        </Row>
      </Panel>
    )
  }

  const handleSortColumn = (sortColumn, sortType) => {
    console.log('handleSortColumn => ', sortColumn, sortType)
    setIsLoadingTable(true)

    handleClickSearch('criOrderBy', `${sortColumn}_${sortType}`)

    setTimeout(() => {
      setSortColumn(sortColumn)
      setSortType(sortType)
      setIsLoadingTable(false)
    }, 500)
  }

  return (
    <>
      <div style={{ marginTop: 50, fontSize: 16 }}>
        {schema.header && (
          <Panel bordered bodyFill style={{ marginTop: 5 }}>
            <Row>
              <Col xs={24} sm={24} md={24} lg={24} className="dashboard-header">
                <p className="dashboard-header-txt">{schema?.header || ''}</p>
              </Col>
            </Row>
          </Panel>
        )}

        <Row>
          <Col xs={24} sm={24} md={24} lg={24}>
            <Panel bordered collapsible defaultExpanded style={{ marginTop: 5 }} header={`  `}>
              {schema?.summary?.length && (
                <Row>
                  {schema?.summary?.map((item, index) => {
                    return (
                      <Col
                        xs={item.setCol.xxs}
                        sm={item.setCol.xsm}
                        md={item.setCol.xmd}
                        lg={item.setCol.xlg}
                      >
                        <CardAmt data={item?.data} />
                      </Col>
                    )
                  })}
                </Row>
              )}
            </Panel>
          </Col>
        </Row>

        {schema?.dashboardInfo && (
          <Row>
            <Col xs={24} sm={24} md={18} lg={18}>
              <Panel bordered collapsible defaultExpanded style={{ marginTop: 5 }} header={`  `}>
                <Row>
                  {schema?.dashboardInfo?.numberPartnersUnitEvaluationTeam && (
                    <Col xs={24} sm={24} md={12} lg={12}>
                      <div className="title-view">
                        {schema?.dashboardInfo?.numberPartnersUnitEvaluationTeam?.title || ''}
                      </div>
                      <DoughnutChart
                        seriesData={
                          schema?.dashboardInfo?.numberPartnersUnitEvaluationTeam?.setting
                            ?.seriesData || []
                        }
                        onClickCheart={(param) => {
                          handleClickSearch('qrtyPerNode', param.id)
                        }}
                      />
                    </Col>
                  )}

                  {schema?.dashboardInfo?.numberPartnersClassifiedAgencyType && (
                    <Col xs={24} sm={24} md={12} lg={12}>
                      <div className="title-view">
                        {schema?.dashboardInfo?.numberPartnersClassifiedAgencyType?.title || ''}
                      </div>
                      <PieChart
                        seriesData={
                          schema?.dashboardInfo?.numberPartnersClassifiedAgencyType?.setting
                            ?.seriesData || []
                        }
                        onClickCheart={(param) => {
                          handleClickSearch('qryPerAgency', param.id)
                        }}
                      />
                    </Col>
                  )}

                  {schema?.dashboardInfo?.numberPartnersBasicKnowledge && (
                    <Col xs={24} sm={24} md={12} lg={12}>
                      <div className="title-view">
                        {schema?.dashboardInfo?.numberPartnersBasicKnowledge?.title || ''}
                      </div>
                      <BasicBarChart
                        xAxisData={
                          schema?.dashboardInfo?.numberPartnersBasicKnowledge?.setting?.xAxisData ||
                          []
                        }
                        seriesData={
                          schema?.dashboardInfo?.numberPartnersBasicKnowledge?.setting
                            ?.seriesData || []
                        }
                        barColor={
                          schema?.dashboardInfo?.numberPartnersBasicKnowledge?.setting?.barColor ||
                          ''
                        }
                        axisLabelConfig={
                          schema?.dashboardInfo?.numberPartnersBasicKnowledge?.setting
                            ?.axisLabelConfig || null
                        }
                        yAxisName={
                          schema?.dashboardInfo?.numberPartnersBasicKnowledge?.setting?.yAxisName ||
                          ''
                        }
                        xAxisName={
                          schema?.dashboardInfo?.numberPartnersBasicKnowledge?.setting?.xAxisName ||
                          ''
                        }
                        xNameLocation={
                          schema?.dashboardInfo?.numberPartnersBasicKnowledge?.setting
                            ?.xNameLocation || ''
                        }
                        xNameGap={
                          schema?.dashboardInfo?.numberPartnersBasicKnowledge?.setting?.xNameGap ||
                          0
                        }
                        onClickCheart={(param) => {
                          handleClickSearch('levelCountKnowledgeSkillSso', param.id)
                        }}
                      />
                    </Col>
                  )}

                  {schema?.dashboardInfo?.basicUnderstandingJob && (
                    <Col xs={24} sm={24} md={12} lg={12}>
                      <div className="title-view">
                        {schema?.dashboardInfo?.basicUnderstandingJob?.title || ''}
                      </div>
                      <BasicBarChart
                        xAxisData={
                          schema?.dashboardInfo?.basicUnderstandingJob?.setting?.xAxisData || []
                        }
                        seriesData={
                          schema?.dashboardInfo?.basicUnderstandingJob?.setting?.seriesData || []
                        }
                        barColor={
                          schema?.dashboardInfo?.basicUnderstandingJob?.setting?.barColor || ''
                        }
                        yAxisName={
                          schema?.dashboardInfo?.basicUnderstandingJob?.setting?.yAxisName || ''
                        }
                        xAxisName={
                          schema?.dashboardInfo?.basicUnderstandingJob?.setting?.xAxisName || ''
                        }
                        xNameLocation={
                          schema?.dashboardInfo?.basicUnderstandingJob?.setting?.xNameLocation || ''
                        }
                        xNameGap={
                          schema?.dashboardInfo?.basicUnderstandingJob?.setting?.xNameGap || 0
                        }
                        onClickCheart={(param) => {
                          handleClickSearch('levelCountKnowledgeSkillSsoDep6', param.id)
                        }}
                      />
                    </Col>
                  )}

                  {schema?.dashboardInfo?.levelUnderstandingProjectEvaluation && (
                    <Col xs={24} sm={24} md={12} lg={12}>
                      <div className="title-view">
                        {schema?.dashboardInfo?.levelUnderstandingProjectEvaluation?.title || ''}
                      </div>
                      <BasicBarChart
                        xAxisData={
                          schema?.dashboardInfo?.levelUnderstandingProjectEvaluation?.setting
                            ?.xAxisData || []
                        }
                        seriesData={
                          schema?.dashboardInfo?.levelUnderstandingProjectEvaluation?.setting
                            ?.seriesData || []
                        }
                        barColor={
                          schema?.dashboardInfo?.levelUnderstandingProjectEvaluation?.setting
                            ?.barColor || ''
                        }
                        yAxisName={
                          schema?.dashboardInfo?.levelUnderstandingProjectEvaluation?.setting
                            ?.yAxisName || ''
                        }
                        xAxisName={
                          schema?.dashboardInfo?.levelUnderstandingProjectEvaluation?.setting
                            ?.xAxisName || ''
                        }
                        xNameLocation={
                          schema?.dashboardInfo?.levelUnderstandingProjectEvaluation?.setting
                            ?.xNameLocation || ''
                        }
                        xNameGap={
                          schema?.dashboardInfo?.levelUnderstandingProjectEvaluation?.setting
                            ?.xNameGap || 0
                        }
                        onClickCheart={(param) => {
                          handleClickSearch('levelCountByProject', param.id)
                        }}
                      />
                    </Col>
                  )}

                  {schema?.dashboardInfo?.projectEvaluationSkillLevel && (
                    <Col xs={24} sm={24} md={12} lg={12}>
                      <div className="title-view">
                        {schema?.dashboardInfo?.projectEvaluationSkillLevel?.title || ''}
                      </div>
                      <BasicLineChart
                        xAxisData={
                          schema?.dashboardInfo?.projectEvaluationSkillLevel?.setting?.xAxisData ||
                          []
                        }
                        seriesData={
                          schema?.dashboardInfo?.projectEvaluationSkillLevel?.setting?.seriesData ||
                          []
                        }
                        barColor={
                          schema?.dashboardInfo?.projectEvaluationSkillLevel?.setting?.barColor ||
                          ''
                        }
                        yAxisName={
                          schema?.dashboardInfo?.projectEvaluationSkillLevel?.setting?.yAxisName ||
                          ''
                        }
                        xAxisName={
                          schema?.dashboardInfo?.projectEvaluationSkillLevel?.setting?.xAxisName ||
                          ''
                        }
                        xNameLocation={
                          schema?.dashboardInfo?.projectEvaluationSkillLevel?.setting
                            ?.xNameLocation || ''
                        }
                        xNameGap={
                          schema?.dashboardInfo?.projectEvaluationSkillLevel?.setting?.xNameGap || 0
                        }
                        onClickCheart={(param) => {
                          handleClickSearch('levelCountByProjectSelfAss', param.id)
                        }}
                      />
                    </Col>
                  )}

                  {schema?.dashboardInfo?.levelUnderstandingCapacityDevelopment && (
                    <Col xs={24} sm={24} md={12} lg={12}>
                      <div className="title-view">
                        {schema?.dashboardInfo?.levelUnderstandingCapacityDevelopment?.title || ''}
                      </div>
                      <BasicBarChart
                        xAxisData={
                          schema?.dashboardInfo?.levelUnderstandingCapacityDevelopment?.setting
                            ?.xAxisData || []
                        }
                        seriesData={
                          schema?.dashboardInfo?.levelUnderstandingCapacityDevelopment?.setting
                            ?.seriesData || []
                        }
                        barColor={
                          schema?.dashboardInfo?.levelUnderstandingCapacityDevelopment?.setting
                            ?.barColor || ''
                        }
                        yAxisName={
                          schema?.dashboardInfo?.levelUnderstandingCapacityDevelopment?.setting
                            ?.yAxisName || ''
                        }
                        xAxisName={
                          schema?.dashboardInfo?.levelUnderstandingCapacityDevelopment?.setting
                            ?.xAxisName || ''
                        }
                        xNameLocation={
                          schema?.dashboardInfo?.levelUnderstandingCapacityDevelopment?.setting
                            ?.xNameLocation || ''
                        }
                        xNameGap={
                          schema?.dashboardInfo?.levelUnderstandingCapacityDevelopment?.setting
                            ?.xNameGap || 0
                        }
                        onClickCheart={(param) => {
                          handleClickSearch('levelUnderstanding', param.id)
                        }}
                      />
                    </Col>
                  )}

                  {schema?.dashboardInfo?.partnetCapacityDevelopmentSkillsLevel && (
                    <Col xs={24} sm={24} md={12} lg={12}>
                      <div className="title-view">
                        {schema?.dashboardInfo?.partnetCapacityDevelopmentSkillsLevel.title || ''}
                      </div>
                      <BasicLineChart
                        xAxisData={
                          schema?.dashboardInfo?.partnetCapacityDevelopmentSkillsLevel?.setting
                            ?.xAxisData || []
                        }
                        seriesData={
                          schema?.dashboardInfo?.partnetCapacityDevelopmentSkillsLevel?.setting
                            ?.seriesData || []
                        }
                        barColor={
                          schema?.dashboardInfo?.partnetCapacityDevelopmentSkillsLevel?.setting
                            ?.barColor || ''
                        }
                        yAxisName={
                          schema?.dashboardInfo?.partnetCapacityDevelopmentSkillsLevel?.setting
                            ?.yAxisName || ''
                        }
                        xAxisName={
                          schema?.dashboardInfo?.partnetCapacityDevelopmentSkillsLevel?.setting
                            ?.xAxisName || ''
                        }
                        xNameLocation={
                          schema?.dashboardInfo?.partnetCapacityDevelopmentSkillsLevel?.setting
                            ?.xNameLocation || ''
                        }
                        xNameGap={
                          schema?.dashboardInfo?.partnetCapacityDevelopmentSkillsLevel?.setting
                            ?.xNameGap || 0
                        }
                        onClickCheart={(param) => {
                          handleClickSearch('levelUnderstandingSelfAss', param.id)
                        }}
                      />
                    </Col>
                  )}
                </Row>
              </Panel>

              <Panel bordered collapsible defaultExpanded style={{ marginTop: 5 }} header={`  `}>
                <Row>
                  {schema?.dashboardInfo?.projectOfArea && (
                    <Col xs={24} sm={24} md={6} lg={6}>
                      <Row>
                        <Col xs={24} sm={24} md={24} lg={24}>
                          <div className="title-view">
                            {schema?.dashboardInfo?.projectOfArea?.title || ''}
                          </div>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={24}>
                          <PieChartsOnGeoMap
                            provinceDataFrom={
                              schema?.dashboardInfo?.projectOfArea?.setting?.provinceDataFrom || []
                            }
                            onClickCheart={(param) => {
                              if (!param?.id) {
                                return false
                              }
                              handleClickSearch('projectArea', param.id)
                            }}
                          />
                        </Col>
                      </Row>
                    </Col>
                  )}

                  {schema?.dashboardInfo?.projectDetail && (
                    <Col xs={24} sm={24} md={18} lg={18}>
                      <Row>
                        <Col xs={24} sm={24} md={24} lg={24}>
                          <div className="title-view">
                            {schema?.dashboardInfo?.projectDetail?.title || ''}
                          </div>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={24}>
                          <Table
                            height={420}
                            data={schema?.dashboardInfo?.projectDetail?.values || []}
                            wordWrap
                            headerHeight={75}
                            sortColumn={sortColumn}
                            sortType={sortType}
                            onSortColumn={handleSortColumn}
                            loading={isLoadingTable}
                            onRowClick={(data) => {
                              console.log(data)
                              handleClickSearch('projectCode', data.id)
                            }}
                            className="table-data"
                          >
                            <Column width={150} align="center" fixed sortable>
                              <HeaderCell>ชื่อ-สกุล</HeaderCell>
                              <Cell dataKey="fullName" />
                            </Column>

                            <Column width={250} sortable>
                              <HeaderCell>บทบาท</HeaderCell>
                              <Cell dataKey="role" />
                            </Column>

                            <Column width={120} sortable>
                              <HeaderCell>ประสบการณ์ทำงาน</HeaderCell>
                              <Cell dataKey="workExperience" />
                            </Column>

                            <Column width={120} sortable>
                              <HeaderCell>ประเภทโครงการ</HeaderCell>
                              <Cell dataKey="projectType" />
                            </Column>

                            <Column width={150} sortable align="right">
                              <HeaderCell>คะแนนประเมิน</HeaderCell>
                              <Cell dataKey="score" />
                            </Column>

                            <Column width={150} sortable align="right">
                              <HeaderCell>หน่วยงานที่สังกัด</HeaderCell>
                              <Cell dataKey="agency" />
                            </Column>

                            <Column width={150} sortable align="right">
                              <HeaderCell>ตำแหน่งงานที่เกี่ยวข้อง</HeaderCell>
                              <Cell dataKey="position" />
                            </Column>

                            <Column width={150} sortable align="right">
                              <HeaderCell>ภาคหน่วยงาน</HeaderCell>
                              <Cell dataKey="sector" />
                            </Column>

                            <Column width={150} sortable align="right">
                              <HeaderCell>จังหวัดหน่วยงาน</HeaderCell>
                              <Cell dataKey="province" />
                            </Column>
                          </Table>
                        </Col>
                      </Row>
                    </Col>
                  )}
                </Row>
              </Panel>
            </Col>

            <Col xs={24} sm={24} md={6} lg={6}>
              <Panel bordered collapsible defaultExpanded style={{ marginTop: 5 }} header={`  `}>
                {schema?.searchForms?.evaluation && (
                  <Row className="filter-box">
                    <Col xs={24} sm={24} md={24} lg={24}>
                      <div className="filter-title">{schema?.searchForms?.evaluation?.label}</div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={24}>
                      <div className="filter-box-input">
                        <Controller
                          name={schema?.searchForms?.evaluation.name}
                          control={control}
                          render={(props) => {
                            return (
                              <CheckPicker
                                data={schema?.searchForms?.evaluation.options}
                                // value={props.value}
                                value={evaluation || []}
                                placeholder="เลือก"
                                block
                                onChange={(value) => {
                                  props.onChange(value)
                                  setEvaluation(value)
                                }}
                              />
                            )
                          }}
                        />
                      </div>
                    </Col>
                  </Row>
                )}

                {schema?.searchForms?.location && (
                  <Row className="filter-box">
                    <Col xs={24} sm={24} md={24} lg={24}>
                      <div className="filter-title">{schema?.searchForms?.location.label}</div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={24}>
                      <div className="filter-box-input">
                        <Controller
                          name={schema?.searchForms?.location.name}
                          control={control}
                          render={(props) => {
                            return (
                              <CheckTreePicker
                                data={schema?.searchForms?.location.options}
                                // value={props.value}
                                value={locationProvince || []}
                                placeholder="เลือก"
                                block
                                onChange={(value) => {
                                  props.onChange(value)
                                  setLocationProvince(value)
                                }}
                              />
                            )
                          }}
                        />
                      </div>
                    </Col>
                  </Row>
                )}

                {schema?.searchForms?.nodeType && (
                  <Row className="filter-box">
                    <Col xs={24} sm={24} md={24} lg={24}>
                      <div className="filter-title">{schema?.searchForms?.nodeType?.label}</div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={24}>
                      <div className="filter-box-input">
                        <Controller
                          name={schema?.searchForms?.nodeType.name}
                          control={control}
                          render={(props) => {
                            return (
                              <CheckPicker
                                data={schema?.searchForms?.nodeType.options}
                                // value={props.value}
                                value={nodeType || []}
                                placeholder="เลือก"
                                block
                                onChange={(value) => {
                                  props.onChange(value)
                                  setNodeType(value)
                                }}
                              />
                            )
                          }}
                        />
                      </div>
                    </Col>
                  </Row>
                )}

                {schema?.searchForms?.roles && (
                  <Row className="filter-box">
                    <Col xs={24} sm={24} md={24} lg={24}>
                      <div className="filter-title">{schema?.searchForms?.roles?.label}</div>
                      {role}
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={24}>
                      <div className="filter-box-input">
                        <Controller
                          name={schema?.searchForms?.roles.name}
                          control={control}
                          render={(props) => {
                            return (
                              <CheckPicker
                                data={schema?.searchForms?.roles.options}
                                // value={props.value}
                                value={role || []}
                                placeholder="เลือก"
                                block
                                onChange={(value) => {
                                  props.onChange(value)
                                  setRole(value)
                                }}
                              />
                            )
                          }}
                        />
                      </div>
                    </Col>
                  </Row>
                )}

                {schema?.searchForms?.rolesUnderTream && (
                  <Row className="filter-box">
                    <Col xs={24} sm={24} md={24} lg={24}>
                      <div className="filter-title">
                        {schema?.searchForms?.rolesUnderTream?.label}
                      </div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={24}>
                      <div className="filter-box-input">
                        <Controller
                          name={schema?.searchForms?.rolesUnderTream.name}
                          control={control}
                          render={(props) => {
                            return (
                              <CheckPicker
                                data={schema?.searchForms?.rolesUnderTream.options}
                                // value={props.value}
                                value={roleUnderTream || []}
                                placeholder="เลือก"
                                block
                                onChange={(value) => {
                                  props.onChange(value)
                                  setRoleUnderTream(value)
                                }}
                              />
                            )
                          }}
                        />
                      </div>
                    </Col>
                  </Row>
                )}

                {schema?.searchForms?.agency && (
                  <Row className="filter-box">
                    <Col xs={24} sm={24} md={24} lg={24}>
                      <div className="filter-title">{schema?.searchForms?.agency?.label}</div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={24}>
                      <div className="filter-box-input">
                        <Controller
                          name={schema?.searchForms?.agency.name}
                          control={control}
                          render={(props) => {
                            return (
                              <CheckPicker
                                data={schema?.searchForms?.agency.options}
                                // value={props.value}
                                value={agency || []}
                                placeholder="เลือก"
                                block
                                onChange={(value) => {
                                  props.onChange(value)
                                  setAgency(value)
                                }}
                              />
                            )
                          }}
                        />
                      </div>
                    </Col>
                  </Row>
                )}

                {schema?.searchForms?.experience && (
                  <Row className="filter-box">
                    <Col xs={24} sm={24} md={24} lg={24}>
                      <div className="filter-title">{schema?.searchForms?.experience?.label}</div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={24}>
                      <div className="filter-box-input">
                        <Controller
                          name={schema?.searchForms?.experience.name}
                          control={control}
                          render={(props) => {
                            return (
                              <CheckPicker
                                data={schema?.searchForms?.experience.options}
                                // value={props.value}
                                value={experience || []}
                                placeholder="เลือก"
                                block
                                onChange={(value) => {
                                  props.onChange(value)
                                  setExperience(value)
                                }}
                              />
                            )
                          }}
                        />
                      </div>
                    </Col>
                  </Row>
                )}

                {schema?.searchForms?.button && (
                  <Row className="filter-box">
                    {schema?.searchForms?.button?.search && (
                      <Col
                        xs={schema?.searchForms?.button?.search?.setCol.xxs}
                        sm={schema?.searchForms?.button?.search?.setCol.xsm}
                        md={schema?.searchForms?.button?.search?.setCol.xmd}
                        lg={schema?.searchForms?.button?.search?.setCol.xlg}
                      >
                        <SaveButton
                          icon={'search'}
                          block
                          children={schema?.searchForms?.button?.search?.label}
                          onClick={() => {
                            handleSearch()
                          }}
                        />
                      </Col>
                    )}

                    {schema?.searchForms?.button?.exportExcel && (
                      <Col
                        xs={schema?.searchForms?.button?.exportExcel?.setCol.xxs}
                        sm={schema?.searchForms?.button?.exportExcel?.setCol.xsm}
                        md={schema?.searchForms?.button?.exportExcel?.setCol.xmd}
                        lg={schema?.searchForms?.button?.exportExcel?.setCol.xlg}
                      >
                        <SaveButton
                          icon={'file-excel-o'}
                          block
                          children={schema?.searchForms?.button?.exportExcel?.label}
                          onClick={() => {
                            handleExportExcel()
                          }}
                        />
                      </Col>
                    )}

                    {schema?.searchForms?.button?.cancel && (
                      <Col
                        xs={schema?.searchForms?.button?.cancel?.setCol.xxs}
                        sm={schema?.searchForms?.button?.cancel?.setCol.xsm}
                        md={schema?.searchForms?.button?.cancel?.setCol.xmd}
                        lg={schema?.searchForms?.button?.cancel?.setCol.xlg}
                      >
                        <CancelButton
                          icon={'close-circle'}
                          block
                          children={schema?.searchForms?.button?.cancel?.label}
                          onClick={() => {
                            handleCancel()
                          }}
                        />
                        {/* <Button color="orange" block size="md" style={{ marginTop: 5 }}>
                          <Icon icon="close-circle" />
                          {`  ${schema?.searchForms?.button?.cancel?.label}`}
                        </Button> */}
                      </Col>
                    )}
                  </Row>
                )}
              </Panel>
            </Col>
          </Row>
        )}
      </div>
    </>
  )
}
